import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
  exact: true,
  path: '/home/operated/notification/new',
  owner: '/home',
  authority: 'notificationItemAdd',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
  },
  {
   exact: true,
   path: '/home/operated/notification/detail/:id',
   owner: '/home',
   authority: 'notificationItemDetail',
   component: Loadable({
     loader: () => import('./detail'),
     loading: () => <RouteLoading />
   })
  }
];